import axios from 'axios';
import * as types from './Auth.types';

const REQUEST_TIMEOUT = 15000;

export const loginService = async (login: types.LoginRequest): Promise<types.LoginResponse> => {
  try {
    const { data } = await axios.post<types.LoginResponse>('https://sistemas.udea.edu.co/api/ldap/login', login, {
      timeout: REQUEST_TIMEOUT,
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 401)
      throw new Error('El usuario o contraseña son incorrectos');
    throw new Error('En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.');
  }
};

export const signupService = async (user: types.SignupRequest): Promise<types.SignupResponse> => {
  try {
    const { data } = await axios.post<types.SignupResponse>('https://sistemas.udea.edu.co/api/ldap/signup', user, {
      timeout: REQUEST_TIMEOUT,
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.data && error.response.data.message)
      throw new Error(error.response.data.message);
    throw new Error('En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.');
  }
};

export const forgotPasswordService = async (email: string): Promise<string> => {
  try {
    const { data } = await axios.post<types.ForgotPasswordResponse>(
      'https://sistemas.udea.edu.co/api/ldap/forgotpassword/generateToken',
      {
        email,
      },
      { timeout: REQUEST_TIMEOUT }
    );
    return data.message;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 401)
      throw new Error(error.response.data.message);
    throw new Error('En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.');
  }
};

export const verifyTokenService = async (token: string): Promise<string> => {
  try {
    const {
      data: { payload },
    } = await axios.get<types.VerifyTokenResponse>('https://sistemas.udea.edu.co/api/ldap/forgotpassword/verifytoken', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: REQUEST_TIMEOUT,
    });

    return payload.key;
  } catch (error) {
    throw new Error('En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.');
  }
};

export const changePasswordService = async (
  changePassword: types.ChangePasswordRequest,
  token: string,
  url: string
): Promise<types.ChangePasswordResponse> => {
  try {
    const { data } = await axios.post<types.ChangePasswordResponse>(
      url,
      {
        ...changePassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        timeout: REQUEST_TIMEOUT,
      }
    );
    return data;
  } catch (error) {
    throw new Error('En este momento el servicio no está disponible. Inténtalo nuevamente más tarde.');
  }
};
